import React from "react";
import {
  getProfileWindowSettings,
  type ProfileWindowSettings,
  setProfileWindowSettings,
  subscribeToProfileWindowSettings,
} from "./profileWindowSettings.store";

/**
 * Reactive view of the profile window settings. The store caches its parsed
 * snapshot, so this stays stable between changes as `useSyncExternalStore`
 * requires.
 */
export default function useProfileWindowSettings(): [
  ProfileWindowSettings,
  (patch: Partial<ProfileWindowSettings>) => void
] {
  const settings = React.useSyncExternalStore(
    subscribeToProfileWindowSettings,
    getProfileWindowSettings,
    () => getProfileWindowSettings()
  );

  const update = React.useCallback((patch: Partial<ProfileWindowSettings>) => {
    setProfileWindowSettings({ ...getProfileWindowSettings(), ...patch });
  }, []);

  return [settings, update];
}
